import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ReactiveFormsModule, FormControl } from '@angular/forms';
import { TreeSelectModule } from 'primeng/treeselect';
import { AutoValidateDirective } from '../../directives/auto-validate.directive';
import { FIELD_CONTROL, FIELD_CONFIG } from './field-tokens';

@Component({
  selector: 'app-field-treeselect',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, TreeSelectModule, AutoValidateDirective],
  template: `
    <p-treeSelect
      [formControl]="formControl"
      [options]="config.options ? config.options() : []"
      appendTo="body"
      [placeholder]="config.placeholder || 'Select'"
      [class]="config.controlClass || 'w-full'"
      [filter]="true"
      filterMode="lenient"
      appAutoValidate />
  `
})
export class TreeselectFieldComponent {
  readonly config  = inject(FIELD_CONFIG);
  readonly control = inject(FIELD_CONTROL);
  get formControl(): FormControl { return this.control as FormControl; }
}
